import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { func } from 'prop-types'
import { Input } from '../../ui/inputs/Input'
import { TextArea } from '../../ui/inputs/TextArea'
import { createStore, stores, view } from '../../../stores'
import { validateReferences } from '../../../utilities/validators'
import { NavigationButtons } from '../../ui/buttons/NavigationButtons'
import { validation } from '../validation'
import { pushGtmTrigger } from '../../../utilities/window'

class NeedsStepComponent extends Component {
  constructor () {
    super()
    const store = createStore({
      pristine: true,
      isValid: false,
      errors: [],
      clear () {
        store.pristine = true
        store.isValid = true
        store.errors = []
      }
    })
    this.store = store
  }

  componentDidMount () {
    // wait for 2 seconds to ensure loading of gtag config
    (new Promise(resolve => setTimeout(resolve, 2000))).then(() => {
      pushGtmTrigger('describe_needs_v2')
    })
  }

  handleSubmit () {
    const { next } = this.props
    let { isValid, errors } = validateReferences(this.refs)

    this.store.errors = errors
    this.store.isValid = isValid
    this.store.pristine = false

    if (isValid) {
      next()
      // TODO(): Update connected account !
    }
  }

  render () {
    const { t } = this.props
    const { errors } = this.store
    return (
      <div className='demande__container'>
        <h3 className='demande-form__h3'>{t('common:create:speak_about_need')}</h3>
        <div className='demande-form__container'>
          <Input
            bold
            label={t('common:fields:surface')}
            name='gardenSurface'
            ref='gardenSurface'
            rules={validation.surface}
            value={stores.inquiry.gardenSurface}
            onChange={(value) => {
              stores.inquiry.gardenSurface = value
              this.store.clear()
            }}
            type='text' />
          <TextArea
            bold
            cols={30}
            label={t('common:fields:description_visit')}
            name='description'
            placeholder='Je voudrais...'
            ref='description'
            onChange={(value) => {
              stores.inquiry.description = value
              this.store.clear()
            }}
            value={stores.inquiry.description}
            required
            rows={10} />
        </div>
        { !this.store.pristine && !this.store.isValid
          ? (
            <div className='form__errormessage' style={{ textAlign: 'center', marginBottom: '10px' }}>
              <b>{ t('common:demande:errors:invalid_form') }</b>
              {errors ? errors.map((e, i) => <div key={i} style={{ }}>{e}</div>) : ''}
            </div>
          ) : ''
        }
        <div className='form__submit'>
          <NavigationButtons next={() => this.handleSubmit()} />
        </div>
      </div>
    )
  }
}

NeedsStepComponent.propTypes = {
  t: func,
  next: func
}

export const NeedsStepV2 = translate()(view(NeedsStepComponent))



// WEBPACK FOOTER //
// ./src/components/inquiry/v2/NeedsStepV2.js